import { Loader } from '@/shared'
import { type IAdmin, type IUpdateAdminDto } from '@App/types/adminsTypes'

import style from './AdminsList.module.scss'
import { EmptyList } from './EmptyList/EmptyList'
import { List } from './List/List'

interface IProps {
    list: IAdmin[] | null
    onUpdateAdminCallback: (dto: IUpdateAdminDto) => void
    removableAdmin: string | null
    setRemovableAdmin: (removableAdmin: string | null) => void
    onRemoveAdmin: (adminId: string) => void
    onAddAdminRole: (login: string, roleName: string, onSuccess: () => void) => void
    onRemoveAdminRole: (login: string, roleName: string, onSuccess: () => void) => void
    isFetchingAdmins: boolean
}

export const AdminsList = (props: IProps) => {
    const {
        list,
        onUpdateAdminCallback,
        setRemovableAdmin,
        removableAdmin,
        onRemoveAdmin,
        onAddAdminRole,
        onRemoveAdminRole,
        isFetchingAdmins
    } = props
    const onRender = () => {
        switch (true) {
            case list && list.length < 1:
                return <EmptyList />
            case list && list.length > 0:
                return (
                    <List
                        list={list || []}
                        onUpdateAdminCallback={onUpdateAdminCallback}
                        removableAdmin={removableAdmin}
                        setRemovableAdmin={setRemovableAdmin}
                        onRemoveAdmin={onRemoveAdmin}
                        onAddAdminRole={onAddAdminRole}
                        onRemoveAdminRole={onRemoveAdminRole}
                        isFetchingAdmins={isFetchingAdmins}
                    />
                )

            default:
                return <Loader />
        }
    }
    return <div className={style.container}>{onRender()}</div>
}
